import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import './HomePage.css'; // Import the CSS file
import './StorePage.css'; // Import the CSS file
import {
  GetCategorysFirstTypeSet,
  getDefaultCategoriesSet,
  findCategoryByType,
  getTypesByCategory,
  GetCategoryTypesSet,
  renderCategoryTypesDom,//render lefe nav menu
  getWordTagsCategoryByType,
  GetWordTagsCategoryTypesSet,
  renderWordTagsCategoryTypesDom,
  getPeriodsCategoryByType,
  GetPeriodsCategoryTypesSet,
  renderPeroidsCategoryTypesDom,
} from './LemmaCategoryTypeUtils';
// import WordTags from './LemmaWordTags';
import { parseProgressUrlParams } from './LemmaPageUtils'
import { Pagination,generateCanonicalLink } from './Paginationhref';
import useLocation from './useLocation';
import CategorySelect from './CategorySelect';
import { categoryIcons } from './CategoryIcons';
import LocalStorageUtil from './user/LocalStorageUtil'
import ChartBlock from './LemmaProgressChartUtils';
import { fetchHeadwordSuggestions } from './popuputils';
import './popupstyle.css';


function CmnLemmaProgress() {
  const freprogpath = 'freprogress';
  const freprogsearchpath = 'freprogresssearch';
  //const cmnlangcode = 'cmn';
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [isSortMenuVisible, setIsSortMenuVisible] = useState(false);
  const [sortOption, setSortOption] = useState('BestMatch');
  const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
  const baseLocalDevUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:3000';
  const [CateTypelinks, setCateTypelinks] = useState([]);
  const [CateTypeslinks, setCateTypeslinks] = useState([]);
  const [WordTagslinks, setWordTagslinks] = useState([]);
  const [Periodslinks, setPeriodslinks] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [basePath, setBasePath] = useState(`${baseLocalDevUrl}/${freprogpath}/all?wordtag=all&page=1`);
  const [curpage, setCurpage] = useState(1);

  const [suggestions, setSuggestions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  // Assuming you have a state to keep track of items
  
  const itemsPerPage = 30; // assuming 10 items per page
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedWordTagsCategory, setselectedWordTagsCategory] = useState('all');
  const [selectedType, setSelectedType] = useState('all');
  const [searchName, setSearchName] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [totalItems, setTotalItems] = useState(0); // initialize to 1 to render pagination early

  const handleSortButtonClick = () => {
    // console.log('Sort button clicked. Current state is:', !isSortMenuVisible); // This should log the expected state chang
    setIsSortMenuVisible(!isSortMenuVisible);
  };

  const handleSortOptionChange = (option) => {
    setSortOption(option);
    setIsSortMenuVisible(false);
    setCategorysFirstType(option);
    triggerSearch(selectedType, searchName, option)
  };


  // Handle the key down event
  const handleKeyDown = (event) => {
    // Check if the Enter key was pressed
    if (event.key === 'Enter') {
      handleSearch();
    }
  };
  const handleCategoryChange = (event) => {
    const newCategory = event.target.value;
    setSelectedCategory(newCategory);
    // If 'all' is not selected, set the first type of the new category as selected
    const typesSet = getTypesByCategory(newCategory);
    if (newCategory !== 'all' && typesSet.length > 0) {
      setSelectedType(typesSet[0]);
    } else {
      setSelectedType('all');
    }
  };

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

 

  const handleSearchInputChange2 = (event) => {
    setSearchName(event.target.value || 'all');
  };

  const handleSearchInputChange = async (event) => {
    const value = event.target.value;
    setSearchName(value);
    // if(value.length < 3){
    //   return;
    // }
    if (value.length >= 3) {
      const results = await fetchHeadwordSuggestions(baseHostUrl,selectedType, value,sortOption);
      setSuggestions(results);
      setShowPopup(true);
    } else {
      setSuggestions([]);
      setShowPopup(false);
    }
  };

  const handleSearch = () => {
    triggerSearch(selectedType, searchName, sortOption);
  };
  

  // Function to trigger the search request
  const triggerSearch = (selectedType, searchName, sortBy) => {
    const name = searchName.trim() !== '' ? searchName : 'all';
    const sortby = sortBy;
    const rating = '=-1';
    const user_ratings_total = '=-1';
    const {para_wordtags,para_period } = parseProgressUrlParams();
    // Call handleSearch with the prepared parameters

      let query = `${baseLocalDevUrl}/${freprogpath}/${encodeURIComponent(selectedType)}?page=1`;

      if (name !== 'all') {
        query += `&name=${encodeURIComponent(name)}`;
      }

      if (sortby !== 'best-match') {
        query += `&sort=${encodeURIComponent(sortby)}`;
      }
      query += `&wordtag=${encodeURIComponent(para_wordtags)}`;
      query += `&period=${encodeURIComponent(para_period)}`;
     // navigate(query)
     window.location.href = query;
    
    // handleRequst(type, name, sortby,rating,user_ratings_total);
    // fetch(query) to make the actual request, then process the response
  };
  const { locationElement, latitude, longitude } = useLocation();
  // Function to perform the actual search
  const handleRequst = async (type,wordtag, name, rating, user_ratings_total, sortby, curpage,para_period) => {

    const query = `${baseHostUrl}/${freprogsearchpath}?type=${encodeURIComponent(type)}` + 
      `&wordtag=${encodeURIComponent(wordtag)}` +
      `&period=${encodeURIComponent(para_period)}` ;

      let pageurl = `${baseLocalDevUrl}/${freprogpath}/${encodeURIComponent(type)}?page=1`;
      pageurl += `&wordtag=${encodeURIComponent(wordtag)}`;
      if (name !== 'all') {
        pageurl += `&name=${encodeURIComponent(name)}`;
      }

      if (sortby !== 'best-match') {
        pageurl += `&sort=${encodeURIComponent(sortby)}`;
      }

    setBasePath(pageurl);
    setCurpage(+curpage);
    try {
      const response = await axios.get(query, {
        withCredentials: true
      });
      const data = response.data;
      setSearchResults(data); // Assuming the response is an array of objects
      setTotalItems(data.length > 0 ? data[0].userRatingsCount || 0 : 0);
    } catch (error) {
      console.error('Failed to fetch search results:', error);
    }
  };
  // useEffect hook to run once the component is mounted
  const setCategorysFirstType = (sortOption) => {
     // Utility: generate first type within each category, with sortOption
    const generatedLinks = GetCategorysFirstTypeSet(baseLocalDevUrl, sortOption,freprogpath);
    setCateTypelinks(generatedLinks);
  };
  // left side types list for a category:
  const setCategoryTypesNav = (selectedCategory,para_wordtags,para_period, sortOption) => {
  //Utility: generate nav links for all types under a category,with sortoption
  const generatedLinks = GetCategoryTypesSet(selectedCategory, baseLocalDevUrl,para_wordtags, sortOption,freprogpath,para_period);
    setCateTypeslinks(generatedLinks);
  };

  // left side types list for a category of Wordtags
  const setWordTagsCategoryTypesNav = (selectedWordTagsCategory,para_type, para_period,sortOption) => {
    //Utility: generate nav links for all types under a category,with sortoption
    const generatedLinks = GetWordTagsCategoryTypesSet(selectedWordTagsCategory, baseLocalDevUrl, para_type,sortOption,freprogpath,para_period);
      setWordTagslinks(generatedLinks);
    };

    
      // left side types list for a category of Period
  const setPeriodCategoryTypesNav = (PeriodCategory,para_type, para_wordtag,sortOption) => {
    //Utility: generate nav links for all types under a category,with sortoption
    const generatedLinks = GetPeriodsCategoryTypesSet(PeriodCategory, baseLocalDevUrl, para_type,sortOption,freprogpath,para_wordtag);
      setPeriodslinks(generatedLinks);
    };
    const handleSuggestionClick = (suggestion) => {
      const name = suggestion.display_name;
    
      setSearchName(name);       // ✅ update the input value
      setSuggestions([]);        // ✅ hide popup
      setShowPopup(false);
    
      // ✅ triggerSearch using current selectedType and sortBy
      triggerSearch(selectedType, name, sortOption);
    }; 
  useEffect(() => {
    //for generate category-first-type link
    const data = LocalStorageUtil.getSession();
    setSession(data);
    // for loading results
    const { para_type, para_name, para_rating, para_reviews, para_sort_by,para_page, para_wordtag,para_period } = parseProgressUrlParams();

    const category = findCategoryByType(para_type);
    const WordTagsCategory = getWordTagsCategoryByType(para_wordtag);
    const PeriodCategory = getPeriodsCategoryByType(para_period);
    setSelectedCategory(category);
    setSelectedType(para_type);
    //setSearchName(para_name);
    setSortOption(para_sort_by);
     // Utility: generate first type within each category, with sortOption
    setCategorysFirstType(para_sort_by);
    //Utility: generate nav links for all period ,with sortoption
    setPeriodCategoryTypesNav(PeriodCategory, para_type,para_wordtag,para_sort_by);
    // Utility: generate nav links for all types under a category,with sortoption
    setCategoryTypesNav(category,para_wordtag,para_period, para_sort_by);

    setWordTagsCategoryTypesNav(WordTagsCategory, para_type,para_period,para_sort_by);
    handleRequst(para_type,para_wordtag, para_name, para_rating, para_reviews, para_sort_by, para_page,para_period).then(() => {
      setIsLoaded(true);
    });;

  }, []); // The empty array means this effect runs only once after initial render

  const { para_type } = parseProgressUrlParams();
  const { para_wordtag } = parseProgressUrlParams();
  const { para_period } = parseProgressUrlParams();
  const category = findCategoryByType(para_type);
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <div className="hpTopBanner">
      <Helmet>
      <title>find best place of {para_type} in ottawa</title>
      <meta name="description"
      content="Learn english"/>

      </Helmet>
      {generateCanonicalLink({ basePath,curpage })}
        <span className="hpLogo">Iezloc</span>
        <span className="hplocation"></span>
        {/* <span className="hplocation" onClick={handleShowModal}>
          {locationElement}</span>
        <GeocodeModal show={showModal} handleClose={handleCloseModal} currentUrl={basePath} /> */}
        <ul className="hpNavigationMenu">
          <li><NavLink to="/" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Home</NavLink></li>
          <li><NavLink to="/lemma" className={({ isActive }) => (isActive ? 'activeLink' : '')} >Lemma</NavLink></li>
          {!session && (
        <>
          <li><NavLink to="/login" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Login</NavLink></li>
          <li><NavLink to="/signup" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Signup</NavLink></li>
        </>
      )}

      {session && (
        <>
        <li><NavLink to="/progress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Progress</NavLink></li>
         <li><NavLink to="/cmnlemma"  className={({ isActive }) => (isActive ? 'activeLink' : '')} >Cmnlemma</NavLink></li>
          <li><NavLink to="/cmnprogress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnprogress</NavLink></li>
          <li><NavLink to="/cmnphrase" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnphrase</NavLink></li>
          <li><NavLink to="/frelemma" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Frelemma</NavLink></li>
          <li><NavLink to="/freprogress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Freprogress</NavLink></li>
          <li><NavLink to="/cmnbook" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnbook</NavLink></li>
          <li><NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Dashboard</NavLink></li>
          <li><NavLink to="/logout" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Logout</NavLink></li>
        </>
      )}

        </ul>
      </div>
      <div className="spContainer">
        <div className="spNavRow1">
          <CategorySelect
            selectedCategory={selectedCategory}
            handleCategoryChange={handleCategoryChange}
            categories={getDefaultCategoriesSet()}
            cateClassname="spCategory"
          />
          <select
            value={selectedType}
            onChange={handleTypeChange}
            className="spType"
            disabled={selectedCategory === 'all'} // Disable if 'All'-categories are selected
          >
            {/* Render the 'All' option only if the selected category is 'all' */}
            {selectedCategory === 'all' && <option value="all">All</option>}
            {getTypesByCategory(selectedCategory).map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
          <div className="spInputContainer">
          </div>
        </div>
        <div className="spNavRow2">
        </div>
        <div className='spNavRow3'>
          {CateTypelinks.map((link, index) => (
            <a key={index} href={link.url} className={`spNavCategoryLink ${link.category === category ? 'sphighlight' : ''}`}>
              <i className={categoryIcons[link.name]} style={{ marginRight: '8px' }}></i>
              {link.name}
            </a>
          ))}
        </div>
        <div className="spTwoColGrid">
          <div className="spLeftNav1">
          {renderPeroidsCategoryTypesDom(Periodslinks, para_period)}
          {renderWordTagsCategoryTypesDom(WordTagslinks, para_wordtag)}
          {renderCategoryTypesDom(CateTypeslinks, para_type)}
          </div>

          <div className="spResultsGrid">
          <ChartBlock data={searchResults} title="User Learning Trend" total={searchResults[0]?.wordsum || 0} />

          </div>
        </div>
        <div className="spNavRow4">
        </div>
      </div>
      <div className={`hpBottomBanner ${isLoaded ? 'visible' : 'hidden'}`}>
        <span className="hpCopyRight">Copyright © iezloc 2024</span>
        <span className="hpContact">info@iezloc.com</span>
        <Link to="/privacy-policy" className="hpPrivacyPolicy">Privacy Policy and Disclaimer</Link>
      </div>
    </>
  );
}


export default CmnLemmaProgress;

